import {DOT, DASH, VARIABLE} from 'effects/midi/tidal/types.js';
import CurrentBlock from './CurrentBlock.js';
import GridToolbar from './GridToolbar.js';
import {
    applyToLeaf,
    applyRule,
    before,
    after,
    when ,
    otherwise,
    ACCENT,
    FLAM,
    STACCATO,
    DOUBLE,
    REST,
    LEGATO,
    PIANO,
    PIANISSIMO
} from 'effects/midi/scripting/trules.js';

import React, { useEffect, useCallback, useState} from 'react';
import {setJakiGridMode} from 'actions/index.js';
import Cell from './Cell.js';
import {connect} from 'react-redux';
import '../../../JakiGrid.scss';

const JakiGridComponent = ({grid, mode, setMode}) => { 
    let [selection, setSelection] = useState(undefined);
    let [dragging, setDragging] = useState(undefined);
    let [selected, setSelected] = useState({});

    useEffect(() => {
        window.addEventListener("mouseup", clearSelection);
        window.addEventListener("keydown", onKeyDown);
        return () => {
            window.removeEventListener("mouseup", clearSelection);
            window.removeEventListener("keydown", onKeyDown);
        }
    }, [setSelection, selection, setSelected, selected]);

    const onKeyDown = useCallback((e) => {
        if (e.key === "Backspace") {
            for (let s in selected) {
                let [x,y] = s.split(',').map((x) => parseInt(x));
                grid.set(x,y,false);
            }
            setSelected({});
        }
    }, [selected, setSelected]);

    const clearSelection = useCallback(() => {
        if (selection) {
            setSelected(grid.getSelected(selection));
            setSelection(undefined);
        }
        if (dragging) {
            setDragging(undefined);
        }
    }, [selection, dragging, setDragging, setSelection, setSelected]);

    return (
        <div className="jaki-grid">
          <GridToolbar setMode={setMode} mode={mode}/>
          <CurrentBlock grid={grid}/>
          {grid.cells.map(
              (row, y) =>
                  <div
                    onClick={e => e.stopPropagation()}
                    onMouseDown={e => e.stopPropagation()}
                    className={y % 2 === 0 ? "jaki-row" : "jaki-row odd"}>
                    {row.map(
                        (cell, x) =>
                            <Cell
                              mode={mode}
                              setDragging={setDragging}
                              dragging={dragging}
                              selected={selected[x+','+y]}
                              setSelection={setSelection}
                              selection={selection}
                              x={x}
                              y={y}
                              grid={grid}
                              odd={x % 2 === 1}
                              />)}
                </div>)}
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
      mode: state.toolbar.jakiGridMode
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setMode: x => dispatch(setJakiGridMode(x))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(JakiGridComponent);
